
import React from 'react'
import Why from '../Home/Why'
import img from "../../assets/quest8.jpeg"

const AdmissionBody = () => {
  return (
    <>
    <section className='w-[75%] md:w-[90%] mx-auto pt-[100px] md:pt-[60px]'>
        <h2 className='text-[#2E2F32] text-4xl my-10 text-center font-medium'>Admission Fees and Tuition</h2>
        <p className='text-[#4E4B4B] text-sm mb-10 font-normal'>At Quest-Inspire, we prioritize affordability and accessibility in our fee structure, ensuring that students receive exceptional value for their investment. Our fee structure is designed to be competitive and affordable, ensuring that students receive excellent value for their investment. We offer flexible payment options and financial assistance programs to accommodate diverse financial situations. Our goal is to make quality education accessible to all, regardless of financial constraints.</p>
        <table className='w-full'>
            <tr className='bg-[#5146AE] py-6 w-full' style={{height: '60px'}}>
                
                <td className='text-white text-left pl-3'>Program</td>
                <td className='text-white'>Session</td>
                <td className='text-white'>Location</td>
                <td className='text-white'>Fee</td>
            </tr>
            <tr style={{height: '60px', borderBottom: '1px solid #C1BDBD'}} className='w-full '>
                <td className='pl-3'>Jamb</td>
                <td>Morning</td>
                <td>Classroom</td>
                <td>#8,000</td>
            </tr>
            <tr style={{height: '60px', borderBottom: '1px solid #C1BDBD'}} className='w-full '>
                <td className='pl-3'>Jamb</td>
                <td>Morning</td>
                <td>Classroom</td>
                <td>#8,000</td>
            </tr>
            <tr style={{height: '60px', borderBottom: '1px solid #C1BDBD'}} className='w-full '>
                <td className='pl-3'>Jamb</td>
                <td>Morning</td>
                <td>Classroom</td>
                <td>#8,000</td>
            </tr>
        </table>
         <button className='bg-[#5146AE] text-white rounded-3xl mb-16 mt-8 px-5 py-3'>Download fee schedule</button>
         <p className='mb-8 leading-8  font-light text-xl text-[#6d6e70]'>
            <b className='font-medium text-[#2E2F32]'>Application Fee:</b> At Quest-Inspire, our application fee is one thousand naira. This one-time fee covers administrative costs and ensures efficient processing of applications. For any inquiries, feel free to contact our admissions office.
         </p>
         <p className='mb-8 leading-8  font-light text-xl text-[#6d6e70]'>
         <b className='font-medium text-[#2E2F32]'>Siblings Fee:</b> At Quest-Inspire, we proudly offer a 5% reduced siblings fee, demonstrating our commitment to supporting families with multiple children enrolled in our programs. This reduction is our way of acknowledging and easing the financial burden on families while ensuring that all siblings can benefit from our quality education. For further information on eligibility and application procedures for the reduced siblings fee, please reach out to our admissions office.
         </p>
         <p className='mb-8 leading-8  font-light text-xl text-[#6d6e70]'>
            <b  className='font-medium text-[#2E2F32]'>Installment payment:</b> Through our installment payment plans, students and families can spread the cost of tuition over several months, making it more manageable and accessible.  The flexible approach to payment empowers individuals to pursue their educational goals without undue financial burden.
         </p>
         <p className='mb-16 leading-8  font-light text-xl text-[#6d6e70]'>
            <b  className='font-medium text-[#2E2F32]'>Foreign Exams:</b> Our experienced instructors offer tailored classes for exams like TOEFL, GRE, SAT, and more. From registrations to personalized study plans, we guide students every step of the way. For details on foreign exams classes and registration assistance, contact us today!
         </p>
        

    </section>
<section className='relative w-full'>
    <img src={img} className='h-[390px] object-cover w-full' alt="Application Form" />
    <section className='w-full absolute top-0 h-full   bg-[#1B135B86] flex justify-center flex-col items-center py-20'>
    <h2 className='text-white font-bold text-5xl text-center'>Application Form</h2>
    <div className='bg-[#5146AE] flex gap-4 w-fit text-center py-3 px-6 rounded-3xl mt-5'>
    <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.25 23.75H26.75V26.25H4.25V23.75ZM16.75 16.465L24.3387 8.875L26.1063 10.6425L15.5 21.25L4.89375 10.6438L6.66125 8.875L14.25 16.4663V2.5H16.75V16.465Z" fill="white"/>
</svg>

        <span className='text-white my-auto'>Download Student Application form</span></div>
    </section>
    </section>
    </>
  )
}

export default AdmissionBody